
    import '/opt/buildhome/repo/components/attachments/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["attachments-demo-basic","attachments-demo-placeholder","attachments-demo-overflow","attachments-demo-with-sender","attachments-demo-files","attachments-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/attachments/index.zh-CN.md?type=demo')
};